// extracted by mini-css-extract-plugin
module.exports = {"block":"jgp-3OP3l","text":"jgp-DVDsb"};